import { z } from 'zod';

export const UserUrlEntitySchema = z.object({
  url: z.string(),
  expandedUrl: z.string().optional(),
  displayUrl: z.string().optional(),
  start: z.number().optional(),
  end: z.number().optional(),
});

export const UserEntitiesSchema = z.object({
  url: z
    .object({
      urls: z.array(UserUrlEntitySchema).optional(),
    })
    .optional(),
  description: z
    .object({
      urls: z.array(UserUrlEntitySchema).optional(),
      hashtags: z
        .array(
          z.object({
            tag: z.string(),
            start: z.number().optional(),
            end: z.number().optional(),
          })
        )
        .optional(),
      mentions: z
        .array(
          z.object({
            username: z.string(),
            start: z.number().optional(),
            end: z.number().optional(),
          })
        )
        .optional(),
    })
    .optional(),
});

export type UserUrlEntity = z.infer<typeof UserUrlEntitySchema>;
export type UserEntities = z.infer<typeof UserEntitiesSchema>;
